import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import TablePageHeading from '../../components/page_heading/TablePageHeading';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import TableList from '../../components/table/TableList';
import CardTabs from '../../components/cards/CardTabs';
import * as app_consts from "../../../utils/app_consts";
import { fail_retrieve_product_types, loading_retrieve_product_types, reset_retrieve_product_types, success_retrieve_product_types } from '../../../reducers/auth_tenant/retrieve_product_types_Slice';
import { RETRIEVE_TENANT_PRODUCT_TYPES_API, RETRIEVE_TENANT_PRODUCTS_API } from '../../../api/api_data';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../utils/Utils';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, RETIREVE_PRODUCT_TYPES_ERROR_MSG, RETIREVE_PRODUCT_TYPES_SUCCESS_MSG } from '../../../utils/error_success_messages';
import AddProductTypeModal from '../../components/modal/AddProductTypeModal';
import { fail_retrieve_products, loading_retrieve_products, reset_retrieve_products, success_retrieve_products } from '../../../reducers/auth_tenant/retrieve_products_Slice';
import AddProductModal from '../../components/modal/AddProductModal';

const Products = ({ tenant_info, user_info }) => {

  const [products_data, setProductsData] = useState([]);
  const [products_loading, setProductsLoading] = useState(true);
  const [products_error, setProductsError] = useState("");
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState("Products");

  const [product_types_data, setProductTypesData] = useState([]);
  const [product_types_error, setProductTypesrror] = useState("");
  const [product_types_loading, setProductTypesLoading] = useState(true);

  const [add_product_type_modal, setAddProductTypeModal] = useState(false);
  const [add_product_modal, setAddProductModal] = useState(false);

  // First COde to Run
  useEffect(() => {
    retrieve_products();
  }, []);

  // Card Tabs
  const tabs = [
    {
      tabName: "Products"
    },
    {
      tabName: "Product Types"
    },
  ];

  const retrieve_products = () => {
    setProductTypesrror("");
    setProductsError("");
    // Retrieve Products
    dispatch(tenant_auth_actions_helper(loading_retrieve_products, success_retrieve_products, fail_retrieve_products, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCTS_API}`));

    // Retrieve Product Types
    dispatch(tenant_auth_actions_helper(loading_retrieve_product_types, success_retrieve_product_types, fail_retrieve_product_types, RETIREVE_PRODUCT_TYPES_ERROR_MSG, RETIREVE_PRODUCT_TYPES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCT_TYPES_API}`));
  };
  // Listen
  const retrieve_product_types_listener = useSelector((state) => state.retrieve_product_types.retrieve_product_types);

  useEffect(() => {
    if (retrieve_product_types_listener.status !== app_consts.IDLE)
    {
      if (retrieve_product_types_listener.status === app_consts.LOADING)
      {
        setProductTypesLoading(true);
        setProductTypesrror("");
      } else
      {
        setProductTypesLoading(false);
        if (retrieve_product_types_listener.status === app_consts.FAIL)
        {
          setProductTypesrror(retrieve_product_types_listener.message, app_consts.FAIL);
          messageToast(retrieve_product_types_listener.message, app_consts.FAIL);
        } else if (retrieve_product_types_listener.status === app_consts.SUCCESS)
        {
          setProductTypesData(retrieve_product_types_listener.data);
        }
        dispatch(reset_retrieve_product_types());
      }
    }
  }, [retrieve_product_types_listener]);

  // Listen
  const retrieve_products_listener = useSelector((state) => state.retrieve_products.retrieve_products);

  useEffect(() => {
    if (retrieve_products_listener.status !== app_consts.IDLE)
    {
      if (retrieve_products_listener.status === app_consts.LOADING)
      {
        setProductsLoading(true);
        setProductsError("");
      } else
      {
        setProductsLoading(false);
        if (retrieve_products_listener.status === app_consts.FAIL)
        {
          setProductsError(retrieve_products_listener.message, app_consts.FAIL);
          messageToast(retrieve_products_listener.message, app_consts.FAIL);
        } else if (retrieve_products_listener.status === app_consts.SUCCESS)
        {
          setProductsData(retrieve_products_listener.data);
        }
        dispatch(reset_retrieve_products());
      }
    }
  }, [retrieve_products_listener]);


  const openAddListModal = (modal_open_type) => {
    if (modal_open_type === app_consts.ADD_PRODUCT_TYPE)
    {
      setAddProductTypeModal(true);
    }
    else if (modal_open_type === app_consts.ADD_PRODUCT)
    {
      setAddProductModal(true);
    }
  };

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Products` : "Products"} />
      <Content>
        {/* Table Page Heading */}
        <TablePageHeading
          title="Products"
          description={activeCardTab === "Products" ? products_data?.length > 0 && `Total Products: ${products_data?.length}` : activeCardTab === "Product Types" ? product_types_data?.length > 0 && `Total Product Types: ${product_types_data?.length}` : ""}
          refresh={!product_types_loading}
          refreshFunc={retrieve_products}
          // csv_export={!loading && !error}
          add_to_list={(product_types_loading) || (product_types_loading) ? "" : user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_PRODUCT_TYPE) || user_info?.roles?.includes(app_consts.ADD_PRODUCT)}
          user_roles={user_info?.roles}
          page_type={app_consts.PRODUCTS_PAGE}
          pageData={activeCardTab === "Products" ? products_data : product_types_data}
          openAddList={openAddListModal}
        />
        <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
        {/* Search Pagee According to Tabs */}
        {
          activeCardTab === "Products" && (
            <>
              {
                products_loading ?
                  <>
                    <AuthTenantLoader tenant_info={tenant_info} />
                  </>
                  :
                  <>
                    {
                      products_error ?
                        <>
                          <AuthTenantPageError tenant_info={tenant_info} error_message={products_error} />
                        </>
                        :
                        <>
                          <TableList
                            // left_head_select
                            type={app_consts.PRODUCTS_MAIN}
                            data={products_data}
                          // rowOptionsData={componentData}
                          // amendFunc={amend_Account_Status_modal}
                          // setOpendModalDetails={setOpendModalDetails}
                          // setSelectedData={setSelectedUser}
                          />
                        </>
                    }
                  </>
              }
            </>
          )
        }
        {
          activeCardTab === "Product Types" && (
            <>
              {
                product_types_loading ?
                  <>
                    <AuthTenantLoader tenant_info={tenant_info} />
                  </>
                  :
                  <>
                    {
                      product_types_error && product_types_error.length > 0 ?
                        <>
                          <AuthTenantPageError tenant_info={tenant_info} error_message={product_types_error} />
                        </>
                        :
                        <>
                          <TableList
                            // left_head_select
                            type={app_consts.PRODUCT_TYPES_MAIN}
                            data={product_types_data}
                          // rowOptionsData={componentData}
                          // amendFunc={amend_Account_Status_modal}
                          // setOpendModalDetails={setOpendModalDetails}
                          // setSelectedData={setSelectedUser}
                          />
                        </>
                    }
                  </>
              }
            </>
          )
        }
      </Content>
      <AddProductTypeModal openModal={add_product_type_modal} setOpenModal={setAddProductTypeModal} modalTitle="Add Product Type" succFunc={retrieve_products} tenant_info={tenant_info} size="md" />
      <AddProductModal openModal={add_product_modal} setOpenModal={setAddProductModal} modalTitle="Add Product" succFunc={retrieve_products} tenant_info={tenant_info} size="md" />
    </>
  );
};

export default Products;
